import type { MapleMythosRunState } from './types';

export const MAPLEMYTHOS_TASK_EVENT = 'maplemythos:task-update';

export interface MapleMythosTaskSnapshot {
  id: string;
  name: string;
  status: MapleMythosRunState['status'];
  progress: number;
  model: string;
  source: 'DeMythos';
  executionMode: MapleMythosRunState['executionMode'];
  billable: boolean;
  loopCount: number;
  maxLoops: number;
  creditsUsed: number;
  tokensUsed: number;
  error?: string;
}

function hasWindow() {
  return typeof window !== 'undefined';
}

export function toMapleMythosTaskSnapshot(run: MapleMythosRunState): MapleMythosTaskSnapshot {
  const completedStates = new Set(['completed', 'failed', 'stopped']);
  const progress = run.maxLoops > 0
    ? Math.min(100, Math.round((run.currentLoop / run.maxLoops) * 100))
    : 0;

  return {
    id: run.id,
    name: run.title || 'DeMythos Run',
    status: run.status,
    progress: completedStates.has(run.status) && run.currentLoop >= run.maxLoops ? 100 : progress,
    model: run.modelName,
    source: 'DeMythos',
    executionMode: run.executionMode,
    billable: run.executionMode === 'cloud',
    loopCount: run.currentLoop,
    maxLoops: run.maxLoops,
    creditsUsed: run.creditsUsed,
    tokensUsed: run.tokensUsed,
    error: run.error,
  };
}

export function emitMapleMythosTaskUpdate(run: MapleMythosRunState) {
  if (!hasWindow()) return;
  window.dispatchEvent(
    new CustomEvent(MAPLEMYTHOS_TASK_EVENT, {
      detail: toMapleMythosTaskSnapshot(run),
    })
  );
}